/**
 * @generated SignedSource<<9c91b0c4f02a8fd6bd7210136fa708ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "appId",
        "variableName": "appId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "APP_NAME_ASC"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AppTsConnection",
  "kind": "LinkedField",
  "name": "appTsByOemAppId",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppOemTemplateFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AppTsConnection",
        "kind": "LinkedField",
        "name": "allAppTs",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AppT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppOemTemplateFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AppTsConnection",
        "kind": "LinkedField",
        "name": "allAppTs",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AppT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4054862f8fcfb0bb0b4b4f897b2ff858",
    "id": null,
    "metadata": {},
    "name": "AppOemTemplateFetchQuery",
    "operationKind": "query",
    "text": "query AppOemTemplateFetchQuery(\n  $accountId: UUID\n  $appId: UUID\n) {\n  allAppTs(condition: {accountId: $accountId, appId: $appId}, orderBy: APP_NAME_ASC) {\n    totalCount\n    nodes {\n      appId\n      appTsByOemAppId {\n        totalCount\n      }\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "5befd99b1f36224b00da73ed69af51f6";

module.exports = node;
